<template>
    <div>
        <v-btn density="compact" color="primary-dark" variant="elevated" elevation="0" @click="openDialog">
            <v-icon icon="mdi-pencil-plus" class="mr-2"></v-icon>
            Ajouter mon PPS
        </v-btn>

        <v-dialog v-model="dialog" max-width="400px">
            <v-card class="pa-2">
                <v-card-title>Renseigner votre numéro de PPS</v-card-title>
                <v-card-text>
                    <div v-if="!pps_validated">
                        <div class="text-body-2 mb-2">
                            <p>Les informations de votre PPS doivent être identiques à celles renseignées pour votre
                                inscription.</p>
                            <div><b>Nom:</b> {{ item.nom }}</div>
                            <div><b>Prénom:</b> {{ item.prenom }}</div>
                            <div><b>Sexe:</b> {{ item.sexe }}</div>
                            <div><b>Date de naissance:</b> Votre date de naissance</div>

                        </div>
                        <v-text-field v-model="numeroPPS" label="Numéro PPS" required></v-text-field>
                        <v-alert  class="mb-2" border="start" border-color="red" elevation="0" v-if="error">{{ error }}</v-alert>
                        <div v-if="error"><v-btn @click="openFiche()" color="primary-dark" variant="text"
                                elevation="0"><v-icon icon="mdi-file"></v-icon>Accèder à ma
                                fiche</v-btn></div>
                    </div>
                    <div v-else>
                        <div class="text-body-2 mb-2">
                            Votre numéro de PPS a été enregistré avec succès.
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div v-if="!pps_validated">
                        <v-spacer></v-spacer>
                        <v-btn color="primary-dark" text @click="closeDialog" :loading="onRequest">Annuler</v-btn>
                        <v-btn color="primary-dark" variant="elevated" elevation="0" @click="submitPPS"
                            :loading="onRequest">Enregistrer</v-btn>
                    </div>
                    <div v-else>
                        <v-spacer></v-spacer>
                        <v-btn color="primary-dark" text @click="closeAfterSuccess">Fermer</v-btn>
                    </div>

                </v-card-actions>


            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import UserService from "@/services/user.service";
export default {
    name: 'ImportPPS',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            onRequest: false,
            dialog: false,
            numeroPPS: '',
            error: "",
            pps_validated: false,
        }
    },
    methods: {
        openFiche() {
            this.$router.push({
                name: 'FicheCoureur'
            })
        },
        openDialog() {
            this.dialog = true
        },
        get_readable_error(error) {
            if (error == 'numero_pps manquant') return "Le numéro PPS est manquant ou incorrect";
            if (error == 'id_inscription manquant' || error == 'num_ffa manquant') return "Une erreur est survenue";
            if (error.includes("PLUS VALIDE AU MOMENT DE LA COMPETITION")) {
                return "Votre numéro de PPS est trop ancien pour cet évenement";
            }
            if (error.includes("IDENTITE DIFFERENTE")) {
                return "Les informations de votre PPS ne correspondent pas à vos informations d'inscription, veuillez vérifier que les informations renseignées soient STRICTEMENT identiques";
            }
            if (error.includes('INTROUVABLE')) {
                return "Le numéro de PPS renseigné n'existe pas, veuillez vérifier le numéro sur votre attestation.";
            }
            if (error.includes('LE NOM NE CORRESPOND PAS')) {
                return "Le nom de famille renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
            }
            if (error.includes('LE PRENOM NE CORRESPOND PAS')) {
                return "Le prénom renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
            }
            if (error.includes('LA DATE DE NAISSANCE NE CORRESPOND PAS')) {
                return "La date de naissance renseignée sur votre PPS ne correspond pas à celle renseigné pour votre inscription";
            }
            if (error.includes('LE SEXE NE CORRESPOND PAS')) {
                return "Le sexe renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
            }
            return "Une erreur est survenue";

        },
        closeAfterSuccess() {
            this.dialog = false
            this.numeroPPS = ''
            this.$emit('onValidPPS');

        },
        closeDialog() {
            this.dialog = false
            this.numeroPPS = ''
        },
        async submitPPS() {
            this.onRequest = true;
            if (this.numeroPPS) {
                if (this.numeroPPS.length < 10) {
                    this.error = "Le numéro de PPS n'est pas valide";
                    this.onRequest = false;
                    return;
                }
                let request = await UserService.updatePPS(this.item.id, this.numeroPPS)
                if (request.error) {
                    this.error = this.get_readable_error(request.error);
                    this.onRequest = false;
                }
                else {
                    if (request.valid_ffa) {
                        this.pps_validated = true;
                    }
                    else {
                        this.error = this.get_readable_error(request.message);
                        this.onRequest = false;
                    }
                }


            }
            this.onRequest = false;
        }
    }
}
</script>
